// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#d3demo{\n\twidth: 100%;\n\t/* height: 50vh; */\n}", "",{"version":3,"sources":["webpack://src/utils/LineCharts/lineChart.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,kBAAkB;AACnB","sourcesContent":["#d3demo{\n\twidth: 100%;\n\t/* height: 50vh; */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
